import {useState} from "react";
import {EventBus, useEventEffect} from "@cirrus/core/events";

interface IState<TPayload> {
	isOpened: boolean,
	payload?: TPayload | null
}
interface Props<TPayload> {
  initialState?: IState<TPayload>,
  bus: EventBus<any>,
  eventNames: {
    open: string,
    close: string
  }
}

const initialState = { isOpened: false, payload: null }

export const useDialog = <TPayload>({bus, eventNames }: Props<TPayload>) => {
  const [state, setState] = useState<IState<TPayload>>(initialState)

  const openDialog = (payload?: TPayload) => setState( {isOpened: true, payload})
  const closeDialog = () => setState(initialState)

  useEventEffect(bus, eventNames.open, openDialog)
  useEventEffect(bus, eventNames.close, closeDialog)

  return {
    ...state, closeDialog, openDialog
  }
}
